import { render, staticRenderFns } from "./ItemTableOs.vue?vue&type=template&id=21543d72&"
import script from "./ItemTableOs.vue?vue&type=script&lang=js&"
export * from "./ItemTableOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports